import moment from 'moment';
import get from 'lodash/get';
import {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {connect, useDispatch} from 'react-redux';

import useError from '../../hooks/useError';
import useUser from '../../hooks/useUser';
import {reset} from '../../redux/reducers/newAppointmentForm';
import {useGetHighlightsQuery} from '../../redux/services/providerHighlightApi';
import {useGetProvidersQuery} from '../../redux/services/providerApi';
import {useGetSessionTypesQuery} from '../../redux/services/sessionTypeApi';
import {useGetReviewsQuery} from '../../redux/services/reviewApi';
import {useCreateAppointmentMutation} from '../../redux/services/appointmentApi';

import AppDashboard from '../AppDashboard';
import NewAppointmentForm from '../../components/scheduling/NewAppointmentForm';

const handleSubmit = ({
  createAppointment,
  onSuccess,
  setError,
  resetForm,
  selectedProviderId,
  sessionTypeId,
}) => async formValues => {
  const body = {
    provider_id: formValues.selectedProviderId,
    session_type_id: formValues.sessionTypeId,
    start_time: moment(
      `${formValues.date} ${formValues.time}`,
      'MM/DD/yyyy hh:mm a'
    ).toISOString()
  };
  const res = await createAppointment(body);
  if (res.error) return setError({message: 'Error scheduling appointment.'});
  resetForm();
  const appointmentId = get(res, 'data.id');
  if (appointmentId) onSuccess(res.data.id);
};

const PatientAppointmentPage = props => {
  const {providerId} = useParams();
  const [step, setStep] = useState(1);
  const {create: setError} = useError();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useUser();
  const providersQuery = useGetProvidersQuery({id: providerId}, {skip: !providerId});
  const highlightsQuery = useGetHighlightsQuery(null, {skip: false});
  const sessionTypesQuery = useGetSessionTypesQuery({providerId}, {skip: !providerId});
  const reviewsQuery = useGetReviewsQuery({provider_id: providerId}, {skip: false});
  const [createAppointment] = useCreateAppointmentMutation();
  const onSuccess = (appointmentId) => navigate(`/appointments/success/${appointmentId}`);
  const provider = providersQuery?.data?.[0] || null;
  const childProps = {
    ...props,
    onSubmit: handleSubmit({
      selectedProviderId: providerId,
      createAppointment,
      onSuccess,
      setError,
      resetForm: () => dispatch(reset()),
    }),
    // data
    selectedProvider: provider,
    highlights: get(highlightsQuery, 'data', []),
    reviews: get(reviewsQuery, 'data', []) || [],
    sessionTypes: get(sessionTypesQuery, 'data', []),
    // config
    loading: !user || sessionTypesQuery.isLoading || providersQuery.isLoading,
    error: sessionTypesQuery.error,
    selectedProviderId: providerId,
    hideManualScheduling: true,
    scheduleManually: false,
    hideStepper: false,
    onPrevScreen: null,
    onMessageProvider: () => navigate(`/clients/messages/${providerId}`),
    scheduleManuallyMessage: 'Please send the provider a message to schedule this appointment type!',
    onScheduleManually: () => navigate(`/clients/messages/${providerId}`),
  };
  return (
    <AppDashboard loading={childProps.loading} error={childProps.error} showBackBtn={props.screenIndex === 0}>
      <NewAppointmentForm {...childProps} backButtonPlacement='top'/>
    </AppDashboard>
  );
};

const mapState = state => ({
  screenIndex: get(state, 'newAppointmentForm.screenIndex', 0),
});

export default connect(mapState)(PatientAppointmentPage);
